import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import * as PIOPIY from 'piopiyjs';
import { ToastrService } from 'ngx-toastr';
import { jwtDecode } from 'jwt-decode';
import { Token } from '@angular/compiler';
import { AuthService } from '../authService/auth.service';
// import { atob } from 'buffer';

@Injectable({
    providedIn: 'root'
})
export class PiopiyService {
    private decodeInfo: any
    private piopiy: any;
    private _incomingCall = new Subject<any>();
    private _callEnded = new Subject<any>();
    private _callAnswered = new Subject<any>();
    private _callFailed = new Subject<any>();
    private _loginStatus = new BehaviorSubject<string>('disconnected');
    private _transferEvent = new Subject<any>();
    private call_Id: any
    
    // Expose Observables
    incomingCall$ = this._incomingCall.asObservable();
    callEnded$ = this._callEnded.asObservable();
    callAnswered$ = this._callAnswered.asObservable();
    callFailed$ = this._callFailed.asObservable();
    loginStatus$ = this._loginStatus.asObservable();
    transferEvent$ = this._transferEvent.asObservable();

    constructor(
        private http: HttpClient,
        private ngZone: NgZone,
        private toaster: ToastrService,
        private authService: AuthService,
    ) { }
    
    showErrorToast(message: string) {
        this.toaster.error(message);
    }
    
    showSuccessToast(message: string) {
        this.toaster.success(message);
    }

    /**
     * Fetches credentials (mocked for now) and connects to Piopiy
     */
    connect(): Observable<any> {
        return this.getCredentials().pipe(
            tap(creds => {
                this.initializePiopiy(creds);
            })
        );
    }

    // private decodeToken() {

    //     if(token){ 
    //         this.decodeInfo = jwtDecode(token);
    //     }
    // }



    /**
     * Mock API call to get credentials
     * TODO: Replace with actual backend API call
     */
    private getCredentials(): Observable<any> {
        // let decodeString: any;
        // const userCredEnc = localStorage.getItem('userInfo')
        // if(userCredEnc){
        // decodeString = JSON.parse(atob(userCredEnc));
        this.decodeInfo = this.authService.getCurrentUser()
        // }
        // Return hardcoded credentials as promised in the plan
        // console.log(Object.hasOwn(this.decodeInfo, 'agent_id'));
        if(Object.hasOwn(this.decodeInfo, 'telecmi')){
        return of({
            username: this.decodeInfo?.telecmi.agent_id,
            password: this.decodeInfo?.telecmi.skey,
            sbcUri: 'sbcind.telecmi.com',
            displayName: 'Admin Agent'
        });
    }
        return of('')


    }

    getCallId(){
        return this.call_Id
    }


    private initializePiopiy(creds: any): void {
        // if (this.piopiy) {
        //     console.log('Piopiy already initialized');
        //     return;
        // }
        if (creds) {
            try {
                console.log('coming to this or not ??');

                this.piopiy = new PIOPIY({
                    name: 'SATCOM',
                    debug: false,
                    autoplay: true,
                    ringTime: 60
                });

                console.log('Logging in to Piopiy with:', creds.username);
                this.piopiy.login(creds.username, creds.password, creds.sbcUri);

                // Event Listeners
                this.piopiy.on('login', (result: any) => {
                    this.ngZone.run(() => {
                        console.log('Piopiy Login Result:', result);
                        if (result.code === 200) {
                            this._loginStatus.next('connected');
                        } else {
                            this._loginStatus.next('failed');
                        }
                        console.log(this.loginStatus$, 'socket status');

                    });
                });

                this.piopiy.on('inComingCall', (callData: any) => {
                    console.log('Piopiy Service: Incoming Call', JSON.stringify(callData, null, 2));
                    console.log(this.piopiy.getCallId(), '<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< ADD THIS call_id ')
                    // We do NOT use ngZone.run() here extensively because the consumer (HeaderComponent)
                    // determines logic. However, emitting through Subject is safe.
                    // But to be extra safe for UI consumers:
                    this.ngZone.run(() => {
                        this._incomingCall.next(callData);
                    });
                });

                this.piopiy.on('ended', (endData: any) => {
                    console.log('Piopiy Service: Call Ended', endData);
                    this.ngZone.run(() => {
                        this._callEnded.next(endData);
                    });
                });

                this.piopiy.on('loginFailed', (error: any) => {
                    console.error('Piopiy Login Failed:', error);
                    this.ngZone.run(() => this._loginStatus.next('failed'));
                });

                this.piopiy.on('logout', (result: any) => {
                    this.ngZone.run(() => {
                        console.log('Piopiy Logout Result:', result);
                        if (result.code === 200) {
                            this._loginStatus.next('disconnected');
                        } else {
                            this._loginStatus.next('failed');
                        }
                    });
                });

                this.piopiy.on('answered', (data: any) => {
                    console.log(data, this.piopiy.getCallId(), 'OOIIDID <<<<<')
                    this.call_Id = this.piopiy.getCallId();
                    this.ngZone.run(() => {
                        console.log('Piopiy Service: Call Answered', data);
                        this._callAnswered.next(data);
                    });
                });

                this.piopiy.on('failed', (data: any) => {
                    this.ngZone.run(() => {
                        console.error('Piopiy Service: Call Failed', data);
                        this._callFailed.next(data);
                    });
                });

            } catch (error) {
                console.log('Error initializing Piopiy:', error);
            }
        } else {
            console.log('PIOPIY initialization skipped: Missing credentials.');
        }
    }

    // --- Call Actions ---

    answer() {
        if (this.piopiy) {
            console.log('PiopiyService: Answering call');
            this.piopiy.answer();
        }
    }

    call(phoneNumber: string): boolean {
        if (!window.navigator.onLine) {
            console.warn('PiopiyService: No internet connection');
            this.toaster.error('No internet connection. Please check your network and try again.');
            return false;
        }

        if (this.piopiy) {
            console.log('PiopiyService: Calling', phoneNumber);
            // Ensure phone number format is correct if needed, e.g. defined country code
            this.piopiy.call(phoneNumber);
            return true;
        } else {
            console.warn('PiopiyService: Not initialized, cannot make call');
            // Optionally try to connect?
            return false;
        }
    }

    reject() {
        if (this.piopiy) {
            console.log('PiopiyService: Rejecting call');
            try {
                this.call_Id = this.piopiy.getCallId();
                this.piopiy.reject();
            } catch (error) {
                console.error('Error in PiopiyService.reject:', error);
            }
        }
    }

    terminate() {
        if (this.piopiy) {
            console.log('PiopiyService: Terminating call');
            try {
                const callId = this.piopiy.getCallId();
                console.log(callId, 'Terminating call with ID');
                this.piopiy.terminate();
            } catch (e) {
                console.warn('Terminate failed, trying reject fallback', e);
                try {
                    this.piopiy.reject();
                } catch (rejectError) {
                    console.error('Reject fallback also failed:', rejectError);
                }
            }
        }
    }

    // Expose the raw instance if absolutely needed (try to avoid)
    getInstance() {
        return this.piopiy;
    }

    disconnect(): void {
        if (!this.piopiy) {
            return;
        }

        console.log('PiopiyService: Disconnecting');

        try {
            if (this.piopiy) {
                this.piopiy.logout();
                this.piopiy = null;
            }
        } catch (error) {
            console.log(error);
        }
    }

    onMute(): void {
        if (!this.piopiy) {
            return;
        }

        try {
            console.log("muting the call.....")
            this.piopiy.mute();
        } catch (error) {
            console.log(error, "mute error");

        }
    }

    onUnMute(): void {
        if (!this.piopiy) {
            return;
        }

        try {
            console.log("unmuting the call.....")
            this.piopiy.unMute();
        } catch (error) {
            console.log(error, "unmute error");

        }
    }

    // Transfer call (use this in future)
    transferCall(number: string): void {
        if (!this.piopiy) {
            return;
        }

        try {
            console.log(number, 'transfer');
            
            this.piopiy.transfer(number, (checkstat: any) => {
                console.log("Transferring the event");
                if (checkstat.code == 100) {
                    console.log("joy k sath call merge ho gaya")
                }
            })
        } catch (error) {
            console.log(error, "Error while transferring the call")
        }
    }

    // Transfer call listeners (use this in future)
    listenTransferEvents(): void {

        if (!this.piopiy) return;

        this.piopiy.on('transfer', (status: any) => {

            console.log('Transfer Event:', status);

            this._transferEvent.next(status)

            if (status.code === 100) {

                console.log('State:', status.state);

                if (status.state === 'init') {
                    console.log('Transfer started');
                }

                if (status.state === 'started') {
                    console.log('Ringing other agent');
                }

                if (status.state === 'bridged') {
                    console.log('Other agent answered');
                }

                if (status.state === 'ended') {
                    console.log('Transfer ended');
                }
            }
        });
    }


    // After call is transferred use this to merge the call
       OnMergeCall(): void {
        if (!this.piopiy) {
            return;
        }

        try {
            console.log("muting the call.....")
            this.piopiy.merge();
        } catch (error) {
            console.log(error, "mute error");

        }
    }
}
